import React from 'react';
import Chart from 'react-apexcharts';

const STAGES = ['upload', 'collect-worker', 'mission-aggregator', 'mission-processor'];

function alignErrorCountByDay(apiData) {
  const records = apiData.results || [];

  // 1) Unique days, sorted
  const allDays = Array.from(new Set(records.map((r) => r.day))).sort(
    (a, b) => new Date(a) - new Date(b)
  );

  // 2) Build a series for each stage
  const series = STAGES.map((stage) => {
    const dataArray = allDays.map((day) => {
      const found = records.find((r) => r.day === day && r.stage === stage);
      return found ? found.failure_count : null;
    });
    return {
      name: stage,
      data: dataArray,
    };
  });

  return { categories: allDays, series };
}

const ErrorCountLineChart = ({ data }) => {
  const { categories, series } = alignErrorCountByDay(data);

  const options = {
    chart: {
      type: 'line',
      height: 350,
      toolbar: { show: true },
    },
    title: {
      text: 'Error Count over Time',
      align: 'center',
    },
    xaxis: {
      categories,
      title: { text: 'Day' },
    },
    yaxis: {
      title: { text: 'Failure Count' },
      min: 0,
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    stroke: {
      curve: 'straight', // or 'smooth'
      width: 2,
    },
    legend: {
      position: 'bottom',
    },
  };

  return (
    <div style={{ marginBottom: '2rem' }}>
      <Chart options={options} series={series} type="line" height={350} />
    </div>
  );
};

export default ErrorCountLineChart;
